export default __webpack_public_path__ + "static/media/information-page-testing.ee903d79.jpg";